<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />
        <div class="container-fluid">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <InputSearch v-model="filtro_text" placeholder="Pesquise por nº/ano" @updateSearch="reloadGrid" />
                </div>
                <div class="ms-2">
                    <button class="btn btn-new-crud" v-on:click="newPropostaCrud">
                        <i class="fas fa-regular fa-plus"></i><span class="ms-2">Adicionar nova proposta</span>
                    </button>
                </div>
            </div>
            <div class="row mt-1" style="padding-left: 13px;padding-right: 13px">
                <DataTable :url_ajax="getUrlPropostas()" :ajax_set_result="setPropostas" @grid_refreshed="gridRefreshed" :request_api="'comercial'"
                           :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                           :footer_fixed="true" :headers="headers" :pBtnsSlot="true" :is_NotLoading="NotLoading" :is_modal="true"
                           :customHeight="lowHeightPage"
                           :customHeightPaginate="lowHeightNoPage"
                           :styleBotton="'bottom:0;left:0;margin-bottom:0;'">
                    <template v-slot:BtnSlot="item">

                        <button class="btn-grid-editar-lista " @click="AbrirAprovarProposta(item.row)" v-if="(item.row.idPropostaEtapa == 2) && (permissoes.flAdministrador == 'Sim' || permissoes.flGestorNovos == 'Sim' || permissoes.flGestorRenovacao == 'Sim'|| permissoes.flGestorSucessoCliente == 'Sim' )">
                            <i class="far fa-thumbs-up" aria-hidden="true"></i>
                            <span :style="widthCustom" class="btn-span-text">Aprovar</span>
                        </button>

                        <button class="btn-grid-editar-lista-v2 " @click="AbrirReprovarProposta(item.row)" v-if="(item.row.idPropostaEtapa == 2) && (permissoes.flAdministrador == 'Sim' || permissoes.flGestorNovos == 'Sim' || permissoes.flGestorRenovacao == 'Sim'|| permissoes.flGestorSucessoCliente == 'Sim' )">
                            <i class="far fa-thumbs-down" aria-hidden="true"></i>
                            <span :style="widthCustom" class="btn-span-text">Reprovar</span>
                        </button>

                        <button class="btn-grid-editar-lista btn-ver-proposta" v-if="item.row.nmRptProposta != ''" @click="verProposta(item.row)">
                            <i class="fas fa-eye" aria-hidden="true"></i>
                            <span :style="widthCustom" class="btn-span-text">Visualizar</span>
                        </button>

                        <button class="btn-grid-editar-lista btn-reenviar-proposta" @click="func_crud(item.row.idProposta, 'Alterar')" v-if="item.row.idPropostaEtapa == 4 || item.row.idPropostaEtapa == 5">
                            <i class="fa fa-paper-plane" aria-hidden="true"></i><span class="btn-span-text">Reenviar</span>
                        </button>

                        <button class="btn-grid-editar-lista btn-editar-proposta" @click="func_crud(item.row.idProposta, 'Alterar')"
                                v-if="item.row.idPropostaEtapa != 2 && item.row.idPropostaEtapa != 4 && item.row.idPropostaEtapa != 5">
                            <i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="btn-span-text">Editar</span>
                        </button>


                        <button class="btn-grid-excluir-lista me-0" @click="func_crud(item.row.idProposta, 'Excluir')"
                                v-if="item.row.idPropostaEtapa < 4">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>

                    </template>
                </DataTable>
            </div>

        </div>

        <modal-warper target="Proposta_Crud" :show="isOpenModalPropostaCrud" @close="(isOpenModalPropostaCrud = false)">
            <Proposta_Crud :idProposta="idProposta" :idOcorrencia="idOcorrencia" :idModulo="idModulo" :show="isOpenModalPropostaCrud" @reloadGrid="reloadGrid" :idInstituicao="idInstituicao" :idEvento="idEvento" :idPessoa="idPessoa" />
        </modal-warper>

        <modal-warper target="ModalConfirmacao_proposta_crud_delete" :show="isOpenModalConfirmacao" @close="(isOpenModalConfirmacao = false)">
            <ModalConfirmacao id="proposta_crud_delete" :title="txtTitle" :show="isOpenModalConfirmacao"
                              :description="''" :red="txtRed" :action="acaoBtn"
                              @actionReturn="escolhaProposta" :CustomIconPersonalizado="iconBtn" />
        </modal-warper>

    </div>
</template>

<script>

    import axios from 'axios';
    import DataTable from '@/components/App/Datatable.vue'
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import InputSearch from '@/components/App/Input_Search.vue'
    import Proposta_Crud from '@/views/Modais/Ocorrencia/Modais/Proposta_Crud_Eventos.vue'
    import ModalConfirmacao from '@/components/App/ModalConfirmacao.vue'
    import CryptoJS from 'crypto-js';

    export default {
        name: 'Propostas',
        components: {
            DataTable,
            ModalWarper,
            OcorrenciaInfo,
            InputSearch,
            Proposta_Crud,
            ModalConfirmacao
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                permissoes: { flAdministrador: 'Não', flGestorNovos: 'Não', flGestorRenovacao: 'Não', flGestorSucessoCliente: 'Não' },

                ocorrencia: {},

                refresh_grid: false,
                filtro: [
                    { active: true },
                ],

                headers: [
                    { class: 'col-1', name: 'nrPropostaAno', text: 'Nº/Ano', order: 0 },
                    { class: 'col-2', name: 'nmPessoa', text: 'Pessoa', order: 0 },
                    { class: 'col-1 text-center', name: 'qtdParticipantes', text: 'Qtd Participantes', order: 0 },
                    { class: 'col-1 text-center', name: 'vlPropostaMascara', text: 'Valor', order: 0 },
                    { class: 'col-1 text-center', name: 'vlDescontoMascara', text: 'Desconto', order: 0 },
                    { class: 'col-1 text-center', name: 'dtGeracao', text: 'Data', order: 0 },
                    { class: 'col-1 pe-0' ,name: 'statusProposta', text: 'Status', order: 0 },
                    { class: 'col-2 ps-3', name: 'dsProcesso', text: 'Processo', order: 0 },
                    { class: 'col-2', name: 'btns', text: '', actions: true }
                ],

                NotLoading: false,
                filtro_text: '',
                idProposta: 0,
                idInstituicao: 0,
                idEvento: 0,
                idPessoa: 0,
                isOpenModalPropostaCrud: false,
                isOpenModalConfirmacao: false,
                Proposta: {},
                Crud_IniciarProposta: {
                    idOcorrencia: 0
                },
                idModulo: 0,
                widthCustom: '',
                evento: { vlInscricao: 0, vlInscricaoOnline: 0 },
                lowHeightPage: '',
                lowHeightNoPage: '',

                acaoBtn: '',
                txtRed: '',
                txtTitle: '',
                iconBtn: '',
            }
        },
        computed: {
        },
        methods: {
            updateLowHeight() {
                if (window.innerWidth <= 1600) {
                    this.lowHeightPage = 'margin-top: 0px !important;max-height: calc(100vh - 23.8rem);min-height: calc(100vh - 23.8rem);'
                    this.lowHeightNoPage = 'margin-top: 0px !important;max-height: calc(100vh - 24.8rem);min-height: calc(100vh - 24.8rem);'
                }
                else if (window.innerWidth >= 1601) {
                    this.lowHeightPage = 'max-height: calc(100vh - 22.rem); min-height: calc(100vh - 22.2rem); margin-top: 0px!important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 23.2rem);min-height: calc(100vh - 23.2rem);margin-top:0px !important';
                }
            },
            GetDadosEvento() {
                let $this = this;

                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API + "/Evento/GetDadosEvento?idEvento=" + this.idEvento,
                    {
                        headers: $this.$api.getTokenEventos(),
                    }
                ).then((response) => {
                    $this.evento = response.data.data;
                });
            },
            getPermissoesUsuario() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Equipe/GetPermissoesUsuarioModulo?idModulo=' + $this.idModulo, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.permissoes = response.data.data;
                })
            },
            escolhaProposta() {
                if (this.vaiAprovar == 1) {
                    this.aprovarProposta(this.Proposta);
                }
                else if (this.vaiAprovar == 2) {
                    this.reprovarProposta(this.Proposta);
                }
                else {
                    this.deleteProposta();
                }
            },
            AbrirAprovarProposta(_proposta) {
                this.Proposta = _proposta;

                this.isOpenModalConfirmacao = true;
                this.vaiAprovar = 1;
                this.acaoBtn = 'Aprovar Proposta';
                this.txtRed = 'Deseja realmente aprovar essa proposta?';
                this.txtTitle = 'Aprovar Proposta';
                this.iconBtn = 'fas fa-check p-2';
            },
            aprovarProposta(_proposta) {
                let $this = this;

                _proposta.vlIndice = 0;
                _proposta.vlDesconto = 0;
                _proposta.vlProposta = 0;

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/AprovarProposta', _proposta, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        $this.reloadGrid();
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });
            },
            AbrirReprovarProposta(_proposta) {
                this.Proposta = _proposta;

                this.isOpenModalConfirmacao = true;
                this.vaiAprovar = 2;
                this.acaoBtn = 'Reprovar Proposta';
                this.txtRed = 'Deseja realmente reprovar essa proposta?';
                this.txtTitle = 'Reprovar Proposta';
                this.iconBtn = 'fas fa-times p-2';
            },
            reprovarProposta(_proposta) {
                let $this = this;

                _proposta.vlIndice = 0;
                _proposta.vlDesconto = 0;
                _proposta.vlProposta = 0;

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/ReprovarProposta', _proposta, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        $this.reloadGrid();
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });
            },
            newPropostaCrud() {
                let $this = this;

                $this.Crud_IniciarProposta.idOcorrencia = $this.idOcorrencia;
                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/PostIniciarPropostaTicket', $this.Crud_IniciarProposta, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {

                        var idProposta = response.data.data;

                        if (idProposta > 0) {
                            $this.func_crud(idProposta, 'Alterar');
                        }

                        $this.reloadGrid();
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });


            },
            func_crud(idProposta, tpAlteracao) {

                this.idProposta = idProposta;

                if (tpAlteracao == 'Alterar') {
                    this.isOpenModalPropostaCrud = true;
                }
                else {
                    this.isOpenModalConfirmacao = true;
                    this.acaoBtn = 'Excluir Proposta';
                    this.txtRed = 'Deseja realmente excluir a proposta?';
                    this.txtTitle = 'Excluir Proposta';
                    this.iconBtn = 'fas fa-trash pe-2';
                }
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace(".", ",");
                val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                return `R$ ${val}`;
            },
            getUrlPropostas() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/GetPropostasOcorrencia?idOcorrencia=' + $this.idOcorrencia;
            },
            setPropostas(result) {
                result.forEach((value, index) => {
                    value.nrPropostaAno = value.nrProposta + '/' + value.nrAno;
                    value.vlPropostaMascara = this.formatPrice(value.vlProposta);
                    value.vlIndice = value.vlIndice + ' % ';
                    if (value.statusProposta == 'Disponível') {
                        if (this.verifica_regra_desconto(value)) {
                            value.statusProposta = '<span id="semRegistros" style="color: #9f3029;">Enviar para aprovação</span>'
                        }
                        else {
                            value.statusProposta = '<span id="">Disponível para envio</span>'
                        }
                    }
                    else if (value.statusProposta == 'Enviada') {
                        value.statusProposta = '<span id="semRegistros" style="color: rgb(60, 118, 61);">Enviada</span>'
                    }
                    else if (value.statusProposta == 'Fracassada') {
                        value.statusProposta = '<span id="semRegistros" style="color: #9f3029;">Fracassada</span>'
                    }
                    else if (value.idPropostaEtapa == 2) {
                        value.statusProposta = '<span id="semRegistros" style="color: #9f3029;">Aguardando aprovação</span>'
                    }
                    else if (value.idPropostaEtapa == 10) {
                        value.statusProposta = '<span id="semRegistros" style="color: #9f3029;">Reprovada</span>'
                    }

                    value.vlDescontoMascara = this.formatPrice(value.vlDesconto);

                })

                return result;
            },
            verifica_regra_desconto(value) {
                let $this = this;

                if (value.idTipoProposta == null) {
                    return false;
                }

                switch (value.idTipoProposta.toString()) {
                    //Presencial
                    case '1':
                        var vlMedioPresencial = (value.vlProposta) / value.qtdInscritos;

                        var valor_desconto_maximo = (this.evento.vlInscricao - this.evento.vlDesconto);
                        valor_desconto_maximo = (this.evento.vlInscricao - valor_desconto_maximo);

                        if (vlMedioPresencial < valor_desconto_maximo) {
                            return true;
                        } else {
                            return false;
                        }
                    //OnLine
                    case '2':
                        var vlMedioOnLine = (value.vlProposta) / value.qtdInscritos;

                        var valor_desconto_maximo2 = (this.evento.vlInscricaoOnline - this.evento.vlDescontoOnline);
                        valor_desconto_maximo2 = (this.evento.vlInscricaoOnline - valor_desconto_maximo2);

                        if (vlMedioOnLine < valor_desconto_maximo2) {
                            return true;
                        } else {
                            return false;
                        }
                    default:
                        if (value.vlDesconto != null && value.vlDesconto > 0) {
                            return true;
                        } else {
                            return false;
                        }
                }
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.idModulo = $this.ocorrencia.idModulo;
                    $this.idInstituicao = $this.ocorrencia.idInstituicao;
                    $this.idPessoa = $this.ocorrencia.idPessoa;
                    $this.idEvento = $this.ocorrencia.idEvento;
                    $this.GetDadosEvento();
                    $this.getPermissoesUsuario();
                })
            },

            gridRefreshed(data_ajax) {
                let $this = this;

                $this.NotLoading = false;
                $this.refresh_grid = false;
            },
            reloadGrid() {
                let $this = this;

                $this.NotLoading = false;
                $this.refresh_grid = true;
            },
            verProposta(proposta) {
                var data_pdf = { path: 'Comercial\\Propostas', name: proposta.nmRptProposta, database: 'NPComercialDB', listParam: 'idProposta', valueParam: proposta.idProposta };
                const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data_pdf), 'reports_gnp').toString();
                var hash = encodeURIComponent(encryptedData);
                window.open(window.location.origin + '/Visualizador_Reports?hash=' + hash, '_blank');
            },
            zerarInformacoes() {

            },
            fecharModal() {
                this.zerarInformacoes();
            },
            deleteProposta() {
                let $this = this;

                axios.delete(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/Delete?idProposta=' + $this.idProposta, {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {
                    $this.$toast.show('success', 'Proposta excluída com sucesso.', true);
                    $this.refresh_grid = true;
                }).catch(error => {
                    var msg = 'Ocorreu um erro inesperado';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }

                    $this.$toast.show('alert', msg, true);
                });
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },

        },
        created() {
        },
        mounted() {
            this.getOcorrencia();
            this.updateLowHeight();

            window.addEventListener('resize', this.updateLowHeight);
        },
        updated() {
            this.updateLowHeight();

        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia(newVal);
                this.reloadGrid();
            },
            idEvento(newVal, oldVal) {
            },
            filtro_text: function (newVal, oldVal) {
                let $this = this;

                $this.NotLoading = true;
                $this.filtro[0].value = newVal;
                $this.refresh_grid = true;
            },
        },
    }

</script>

<style scoped lang="scss">

    .btn-ver-proposta {
        background-color: #299F43;
    }

    .btn-reenviar-proposta {
        background-color: #9F7029;
    }

    .btn-editar-proposta {
        background-color: #297C9F;
    }
     
    .datatable-email .body-class-personalizada {
        height: calc(100vh - 34rem) !important;
    }

    .btn-icon {
        width: 47px;
    }

    .semRegistros {
        color: #9f3029;
        padding: 7px 15px;
    }

    .classEnviada {
        color: rgb(60, 118, 61);
    }

    .btn-grid-excluir-lista {
        width: unset;
        max-height: 35px;
    }

    </style>